export const COMPANY = {
  API_BASE_URL :"https://apikyc.vkstockvission.in",
  // API_BASE_URL: "http://localhost:4000",
  NAME: " VKSTOCKVISION .",
  SHORT_NAME: "VKSTOCKVISION ",
  SEBI_REG_NO: "INH000019831 ",
  SEBI_REG_DATE: "Mar 19, 2024",

  ADDRESS:
    " Mumbai, Maharashtra, 411033",

  CONTACT: {
    PHONE: "8000489090",
    EMAIL: "info@vkstockvission.in",
  },

  FEES: {
    MAX_PER_YEAR: "₹1.51 lakhs",
  },

  LINKS: {
    SCORES: "https://scores.sebi.gov.in",
    SMART_ODR: "https://smartodr.in",
  },
};
